import { render, staticRenderFns } from "./FreeStockBanner.vue?vue&type=template&id=0946de9d&scoped=true&"
import script from "./FreeStockBanner.vue?vue&type=script&lang=js&"
export * from "./FreeStockBanner.vue?vue&type=script&lang=js&"
import style0 from "./FreeStockBanner.vue?vue&type=style&index=0&id=0946de9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0946de9d",
  null
  
)

export default component.exports